import React, { useState } from 'react';
import { Bot } from 'lucide-react';
import ChatList from './ChatList';
import ChatView from './ChatView';

function AdminPanel({ userId, setActiveComponent }) {
  const [chatId, setChatId] = useState(null);

  const handleBackToMenu = () => {
    setChatId(null);
    if (typeof setActiveComponent === 'function') {
      setActiveComponent('OptionsAdmin');
    }
  };

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-100">
      <div className={`${chatId ? 'hidden sm:block' : 'block'} w-full sm:w-[430px] flex-shrink-0`}>
        <ChatList
          userId={userId}
          onSelect={setChatId}
          selectedChatId={chatId}
        />
      </div>

      <div className={`${chatId ? 'flex' : 'hidden sm:flex'} flex-col flex-1 min-w-0`}>
        {chatId ? (
          <ChatView
            chatId={chatId}
            setActiveComponent={setActiveComponent}
            onBackClick={handleBackToMenu}
            userId={userId}
          />
        ) : (
          <div className="flex-1 flex items-center justify-center bg-slate-100">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-white border border-slate-200 flex items-center justify-center mb-4 shadow-sm">
                <Bot className="w-8 h-8 text-[#B1336E]" />
              </div>
              <h3 className="text-lg font-bold text-slate-950">Selecciona una conversacion</h3>
              <p className="text-sm text-slate-500 mt-1">Prioriza reclamos, borradores AI y chats sin leer desde la izquierda.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPanel;
